import CTAButton from '../buttons/CTAButton';
import React from 'react';
import styles from '../../css/components/overlays/ssoConfirmationOverlay.css';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function SsoConfirmationOverlay({ handleConfirmSsoLogin }) {
	const { t } = useTranslation('translation');

	return (
		<div className={ styles.ssoConfirmation }>
			<CTAButton
				onButtonClick={handleConfirmSsoLogin}
				buttonLabel={t('loginForm.ctaButton')}
				buttonId='popup_sso/button_login-confirm'
			/>
		</div>
	);
}

export default SsoConfirmationOverlay;
SsoConfirmationOverlay.propTypes = {
	handleConfirmSsoLogin: PropTypes.func.isRequired
};